var map = {
	"./BOT.jpg": 8386,
	"./TOP.jpg": 9354,
	"./content.txt": 8781,
	"./global.css": 8645,
	"./image1.jpg": 2390,
	"./image10.jpg": 1521,
	"./image11.jpg": 7839,
	"./image12.jpg": 3089,
	"./image13.png": 3813,
	"./image14.jpg": 726,
	"./image15.jpg": 7174,
	"./image16.jpg": 8193,
	"./image17.jpg": 6971,
	"./image18.png": 6053,
	"./image19.png": 4919,
	"./image2.jpg": 1374,
	"./image20.png": 9122,
	"./image21.jpg": 4863,
	"./image3.jpg": 5680,
	"./image4.jpg": 6692,
	"./image5.jpg": 5904,
	"./image6.jpg": 3262,
	"./image7.jpg": 7421,
	"./image8.jpg": 247,
	"./image9.jpg": 5430,
	"./logo.png": 6949,
	"./voice1.m4a": 7032,
	"./voice2.mp3": 900,
	"./voice3.mp3": 5451,
	"./voice4.m4a": 539,
	"./voice5.m4a": 2258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;